import React from 'react';

var Upload = function Upload(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 10.414l3.293 3.293a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L11 10.414V20a1 1 0 0 0 2 0v-9.586zM5 3a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2H5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Upload.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Upload as icon };
export default iconHandler(Upload);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Upload.js
// module id = 630
// module chunks = 0